/* eslint-disable react/destructuring-assignment */
import * as React from "react";

const Calendar12Icon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={16} fill="none" {...props}>
    <path
      fill={props.color || "#334155"}
      d="M13.5 2H12v-.5a.5.5 0 0 0-1 0V2H6v-.5a.5.5 0 1 0-1 0V2H3.5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1ZM5 3v.5a.5.5 0 1 0 1 0V3h5v.5a.5.5 0 0 0 1 0V3h1.5v2h-10V3H5Zm8.5 10h-10V6h10v7Zm-6-5.5v4a.5.5 0 0 1-1 0V8.309l-.276.139a.5.5 0 0 1-.448-.896l1-.5A.5.5 0 0 1 7.5 7.5Zm3.697 1.903L10 11h1a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.4-.8l1.799-2.398a.499.499 0 1 0-.832-.552.5.5 0 1 1-.866-.5 1.5 1.5 0 1 1 2.496 1.653Z"
    />
  </svg>
);
export default Calendar12Icon;
